import './Banner.css';

export const Banner = () => {
    return (
        <header className="banner">
            <img src="/imagens/banner.png" alt="Banner principal da página do Organo"/>
        </header>
    )
}